import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.every.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.reduce.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { downloadExcelOS, fetchOutstandingDealers } from '@/api/orders-dispatches';
import Pagination from '@/components/Pagination/index.vue';
import { getQuery } from '@/utils/index';
import Inr from '@/components/Inr/index.vue';
import { getAgentById, getAgents } from '@/api/agents';
import { AdminModule } from '@/store/modules/admin';
import { searchDealers } from '@/api/dealers';
import { cleanListQuery, isAdmin, isSuperAdmin } from '@/common';
import { BranchAgentService } from '@/services/branch-agent-service';
import moment from 'moment';
let default_1 = class extends Vue {
  constructor() {
    super(...arguments);
    this.tableKey = 0;
    this.total = 0;
    this.totalBalance = 0;
    this.list = [];
    this.listLoading = true;
    this.isAgent = false;
    this.agentList = [];
    this.dealerList = [];
    this.branchListLoading = false;
    this.branchList = [];
    this.dealerListLoading = false;
    this.dateRange = '';
    this.downloadLoading = false;
    this.totalGrandTotal = '';
    this.assignedBranches = [] || null;
    this.agentUserList = [];
    this.listQuery = {
      page: 1,
      limit: 10,
      dealerId: undefined,
      agentId: undefined,
      startDate: undefined,
      endDate: undefined,
      branchId: undefined,
      excludeBranches: false,
      fromDashboard: false,
      applyBranchIdFilter: true,
      assignedAgentId: undefined
    };
    this.shortcuts = [{
      key: 'thisWeek',
      label: 'This week',
      value: 'isoWeek'
    }, {
      key: 'lastWeek',
      label: 'Last week',
      value: '-isoWeek'
    }, {
      key: 'last7Days',
      label: 'Last 7 days',
      value: 7
    }, {
      key: 'last30Days',
      label: 'Last 30 days',
      value: 30
    }, {
      key: 'thisMonth',
      label: 'This month',
      value: 'month'
    }, {
      key: 'lastMonth',
      label: 'Last month',
      value: '-month'
    }, {
      key: 'thisYear',
      label: 'This FY',
      value: () => {
        const currentDate = moment();
        let startYear = currentDate.year();
        // Financial year starts in April
        const startMonth = 3; // April (0-indexed as 3 in moment.js)
        const startDay = 1;
        if (currentDate.month() <= 2) {
          // If before April, move to the previous financial year
          startYear--;
        }
        const thisFinancialYearStart = moment([startYear, startMonth, startDay]);
        const thisFinancialYearEnd = moment([startYear + 1, startMonth, startDay]).subtract(1, 'days');
        return {
          start: thisFinancialYearStart,
          end: thisFinancialYearEnd
        };
      }
    }, {
      key: 'lastYear',
      label: 'Last FY',
      value: () => {
        const currentDate = moment();
        let startYear = currentDate.year();
        // Financial year starts in April
        const startMonth = 3;
        const startDay = 1;
        if (currentDate.month() <= 2) {
          // Before April, use the previous financial year
          startYear--;
        }
        const lastFinancialYearStart = moment([startYear - 1, startMonth, startDay]);
        const lastFinancialYearEnd = moment([startYear, startMonth, startDay]).subtract(1, 'days');
        return {
          start: lastFinancialYearStart,
          end: lastFinancialYearEnd
        };
      }
    }];
  }
  onCheckboxChange(value) {
    this.listQuery.excludeBranches = value;
  }
  _isAdminRoles() {
    return isSuperAdmin() || isAdmin();
  }
  async activated() {
    try {
      // check if logged in user is Agent/Admin
      if (AdminModule.userType === 'Agent') {
        this.isAgent = true;
        this.listQuery.agentId = AdminModule.agentId;
      }
      this.listQuery.excludeBranches = true;
      // Extract branchId from the URL
      const branchIdFromURL = this.$route.query.branchId;
      // If branchId exists in the URL, assign it
      if (branchIdFromURL) {
        this.listQuery.branchId = branchIdFromURL;
      }
      // Assign branchId using BranchAgentService
      // this.listQuery.branchId = await BranchAgentService.assignBranchId();
      this.assignedBranches = await BranchAgentService.assignBranchId();
      // Check if branchId is null and throw an error
      if (this.assignedBranches === null) {
        throw new Error('You are not assigned to a branch.');
      }
      // Fetch agents for the assigned branchId
      this.agentList = await BranchAgentService.fetchAgents(this.assignedBranches);
      // Fetch branches for non-super admin users
      this.branchList = await BranchAgentService.fetchBranches(this.assignedBranches);
      // initialize start date and end date
      this.dateRange = {
        start: this.$moment('2022-04-01').format('YYYY-MM-01 12:00') + ' am',
        end: this.$moment().endOf('day').format('YYYY-MM-DD 11:59') + ' pm'
      };
      this.getList();
    } catch (err) {
      if (err instanceof Error) {
        this.$notify.error({
          title: 'Error',
          message: err.message
        });
      }
      this.listLoading = false;
    }
  }
  async getList() {
    try {
      this.listQuery = cleanListQuery(this.listQuery);
      if (this.dateRange) {
        this.listQuery.startDate = this.dateRange.start;
        this.listQuery.endDate = this.dateRange.end;
      }
      this.listLoading = true;
      const data = await fetchOutstandingDealers(this.listQuery);
      this.list = data.data;
      this.totalBalance = data.totalBalance;
      this.totalGrandTotal = data.grandTotal;
      this.total = data.total;
      this.listLoading = false;
    } catch (error) {
      this.listLoading = false;
    }
  }
  sortChange(data) {
    const {
      prop,
      order
    } = data;
    if (prop) {
      this.listQuery.sort = `${prop},` + (order === 'ascending' ? 'ASC' : 'DESC');
      this.handleFilter();
    }
  }
  async getDealerList(query = null) {
    try {
      const isNumeric = /^[0-9]+$/.test(query);
      // search only if length is greater than 1 if query is id else 2
      if (!query || (isNumeric ? query.length < 1 : query.length < 2)) {
        this.dealerList = [];
        return;
      }
      const searchParams = {
        keyword: query,
        searchBy: isNumeric ? 'dealerId' : 'name',
        applyBranchIdFilter: true,
        branchId: null,
        agentId: null
      };
      if (this.listQuery.branchId !== undefined) {
        searchParams.branchId = this.listQuery.branchId;
      }
      if (this.listQuery.agentId !== undefined) {
        searchParams.agentId = this.listQuery.agentId;
      }
      this.dealerList = await searchDealers(searchParams);
    } catch (error) {} // eslint-disable-line  no-empty
  }
  async handleFilter() {
    var _AdminModule$branchId;
    this.listQuery.page = 1;
    // handle branch and agent code
    // Fetch agents for a single branch
    if (this.listQuery.agentId) {
      const agentData = await getAgentById(this.listQuery.agentId);
      this.agentUserList = agentData.agentUser.filter(user => user.roles.some(role => role.name === 'Sales Executive'));
    }
    if ((!isSuperAdmin() || !isAdmin()) && ((_AdminModule$branchId = AdminModule.branchIds) === null || _AdminModule$branchId === void 0 ? void 0 : _AdminModule$branchId.length) === 1) {
      this.listQuery.branchId = AdminModule.branchIds[0];
    }
    if (this.listQuery.branchId !== undefined && this.listQuery.branchId.length > 0) {
      // Fetch agents and branches for non-superadmin/admin users
      this.agentList = await BranchAgentService.fetchAgents(this.listQuery.branchId);
      await BranchAgentService.fetchBranches(this.listQuery.branchId);
      // Fetch the list after agents and branches are loaded
      this.getList();
    } else {
      // await this.handleClearBranch();
      this.getList();
    }
  }
  async handleExcelDownload() {
    this.downloadLoading = false;
    this.listQuery = cleanListQuery(this.listQuery);
    try {
      const query = this.listQuery;
      let startDate = '';
      let endDate = '';
      if (this.listQuery.startDate && this.listQuery.endDate) {
        startDate = this.listQuery.startDate;
        endDate = this.listQuery.endDate;
      }
      // let datas: any = await this.getListWithoutPagination();
      // let data = datas.data;
      const blob = await downloadExcelOS({
        query,
        startDate,
        endDate,
        applyBranchIdFilter: true
      });
      // Create a blob URL for the Excel file
      const url = window.URL.createObjectURL(blob);
      // Create a temporary link element
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'Outstanding.xlsx');
      document.body.appendChild(link);
      // Simulate click to trigger download
      link.click();
      // Clean up
      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);
    } catch (error) {
      console.error('Error downloading Excel:', error);
      this.$message.error('Error downloading Excel');
    } finally {
      // Reset loading state
      this.downloadLoading = false;
    }
  }
  async fetchAgents() {
    this.agentList = await getAgents(getQuery({
      enabled: true,
      sort: 'name,ASC',
      filter: {
        enabled: 'eq'
      }
    }));
  }
  getSummaries(param) {
    const {
      columns,
      data
    } = param;
    const sums = [];
    const totalGrandTotalRow = [];
    columns.forEach((column, index) => {
      // First column - labels
      if (index === 0) {
        sums[index] = 'Total Page:';
        totalGrandTotalRow[index] = 'Grand Total:';
        return;
      }
      // Outstanding column (index 2)
      if (index === 2) {
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          const pageTotal = values.reduce((prev, curr) => {
            const value = Number(curr);
            return !isNaN(value) ? prev + value : prev;
          }, 0);
          sums[index] = pageTotal.toFixed(2);
          totalGrandTotalRow[index] = parseFloat(this.totalGrandTotal).toFixed(2);
        } else {
          sums[index] = 'N/A';
          totalGrandTotalRow[index] = 'N/A';
        }
      }
    });
    return [sums, totalGrandTotalRow];
  }
};
default_1 = __decorate([Component({
  name: 'DealerList',
  components: {
    Pagination,
    Inr
  }
})], default_1);
export default default_1;